import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enUS from './en-US.json';
import enUK from './en-UK.json';
import frFR from './fr-FR.json';
import enEU from './en-EU.json';
import deDE from './de-DE.json';

const resources = {
  US: {
    translation: enUS,
  },
  UK: {
    translation: enUK,
  },
  FR: {
    translation: frFR,
  },
  EU: {
    translation: enEU,
  },
  DE: {
    translation: deDE,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'US',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
